/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Facetedfilter_Clearfilters2Inputs */

const id_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus filter`)
};

const ms_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosongkan penapis`)
};

const da_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ryd filtre`)
};

const de_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter zurücksetzen`)
};

const en_us2_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear filters`)
};

const es_es2_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpiar filtros`)
};

const es_mx2_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpiar filtros`)
};

const fil_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-clear ang mga filter`)
};

const fr_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer les filtres`)
};

const it_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella filtri`)
};

const hu_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szűrők törlése`)
};

const nl_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filters wissen`)
};

const no_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tøm filtre`)
};

const pl_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyczyść filtry`)
};

const pt_br2_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear filters`)
};

const pt_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar filtros`)
};

const ro_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Șterge filtrele`)
};

const fi_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tyhjennä suodattimet`)
};

const sv_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rensa filter`)
};

const vi_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa bộ lọc`)
};

const tr_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtreleri temizle`)
};

const cs_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vymazat filtry`)
};

const bg_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изчистване на филтрите`)
};

const ru_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить фильтры`)
};

const uk_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистити фільтри`)
};

const ar_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسح عوامل التصفية`)
};

const hi_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़िल्टर साफ़ करें`)
};

const th_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ล้างตัวกรอง`)
};

const ja_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィルターをクリア`)
};

const zh_cn2_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear filters`)
};

const zh_hant1_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear filters`)
};

const ko_table_facetedfilter_clearfilters2 = /** @type {(inputs: Table_Facetedfilter_Clearfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear filters`)
};

/**
* | output |
* | --- |
* | "Clear filters" |
*
* @param {Table_Facetedfilter_Clearfilters2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_facetedfilter_clearfilters2 = /** @type {((inputs?: Table_Facetedfilter_Clearfilters2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Facetedfilter_Clearfilters2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_facetedfilter_clearfilters2(inputs)
	if (locale === "ms") return ms_table_facetedfilter_clearfilters2(inputs)
	if (locale === "da") return da_table_facetedfilter_clearfilters2(inputs)
	if (locale === "de") return de_table_facetedfilter_clearfilters2(inputs)
	if (locale === "en-US") return en_us2_table_facetedfilter_clearfilters2(inputs)
	if (locale === "es-ES") return es_es2_table_facetedfilter_clearfilters2(inputs)
	if (locale === "es-MX") return es_mx2_table_facetedfilter_clearfilters2(inputs)
	if (locale === "fil") return fil_table_facetedfilter_clearfilters2(inputs)
	if (locale === "fr") return fr_table_facetedfilter_clearfilters2(inputs)
	if (locale === "it") return it_table_facetedfilter_clearfilters2(inputs)
	if (locale === "hu") return hu_table_facetedfilter_clearfilters2(inputs)
	if (locale === "nl") return nl_table_facetedfilter_clearfilters2(inputs)
	if (locale === "no") return no_table_facetedfilter_clearfilters2(inputs)
	if (locale === "pl") return pl_table_facetedfilter_clearfilters2(inputs)
	if (locale === "pt-BR") return pt_br2_table_facetedfilter_clearfilters2(inputs)
	if (locale === "pt") return pt_table_facetedfilter_clearfilters2(inputs)
	if (locale === "ro") return ro_table_facetedfilter_clearfilters2(inputs)
	if (locale === "fi") return fi_table_facetedfilter_clearfilters2(inputs)
	if (locale === "sv") return sv_table_facetedfilter_clearfilters2(inputs)
	if (locale === "vi") return vi_table_facetedfilter_clearfilters2(inputs)
	if (locale === "tr") return tr_table_facetedfilter_clearfilters2(inputs)
	if (locale === "cs") return cs_table_facetedfilter_clearfilters2(inputs)
	if (locale === "bg") return bg_table_facetedfilter_clearfilters2(inputs)
	if (locale === "ru") return ru_table_facetedfilter_clearfilters2(inputs)
	if (locale === "uk") return uk_table_facetedfilter_clearfilters2(inputs)
	if (locale === "ar") return ar_table_facetedfilter_clearfilters2(inputs)
	if (locale === "hi") return hi_table_facetedfilter_clearfilters2(inputs)
	if (locale === "th") return th_table_facetedfilter_clearfilters2(inputs)
	if (locale === "ja") return ja_table_facetedfilter_clearfilters2(inputs)
	if (locale === "zh-CN") return zh_cn2_table_facetedfilter_clearfilters2(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_facetedfilter_clearfilters2(inputs)
	return ko_table_facetedfilter_clearfilters2(inputs)
});
export { table_facetedfilter_clearfilters2 as "table.facetedFilter.clearFilters" }